exports.components = {
  "component---src-pages-endpoints-js": () => import("./../../../src/pages/endpoints.js" /* webpackChunkName: "component---src-pages-endpoints-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

